module.exports = __webpack_public_path__ + "media/metal_2.9d4883e4.webm";